import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Item do Recebimento", -1)
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_10 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_11 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Total do Produto", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Total da Venda", -1)
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-3",
  style: {"background-color":"#40a9ff"}
}
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-movimento-comercial-campo-totalizador" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","font-weight":"bolder"} }, "Total do Item", -1)
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  class: "ant-row",
  style: {"height":"100%"}
}
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_43 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_44 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "ant-row" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_50 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_51 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_52 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_57 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_58 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_59 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_60 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_unidade = _resolveComponent("selecionar-unidade")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_cfop = _resolveComponent("selecionar-cfop")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_nota_fiscal_item_detalhe = _resolveComponent("nota-fiscal-item-detalhe")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_item_impostos = _resolveComponent("nota-fiscal-item-impostos")!
  const _component_nota_fiscal_item_estoques = _resolveComponent("nota-fiscal-item-estoques")!
  const _component_recebimento_mercadorias_item_custo = _resolveComponent("recebimento-mercadorias-item-custo")!
  const _component_nota_fiscal_item_dados_especificos = _resolveComponent("nota-fiscal-item-dados-especificos")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    maskClosable: false,
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-compras' : 'scroll-modal ss-modal-compras'
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Item Anterior"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeAnterior || _ctx.state.item.codigo === undefined,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.itemAnterior && _ctx.itemAnterior(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-anterior" })
              ], 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Próximo Item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeProximo || _ctx.state.item.codigo === undefined,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.proximoItem && _ctx.proximoItem(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-proximo" })
              ], 8, _hoisted_6)
            ]),
            _: 1
          }),
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
              }, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.precoUnitario * _ctx.state.item.itemNotaFiscal.quantidade, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_24)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.outrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_27)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.impostos.valorTotalTributos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_30)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.totalNota, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_33)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: {"background-color":"#40a9ff","color":"white","font-weight":"bolder"},
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.itemNotaFiscal.valorTotal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_38)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card, { class: "ss-card" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_a_form_item, {
                            label: "Produto",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_produto, {
                                apresentarCodigoInterno: true,
                                modoDefinicaoProduto: true,
                                limparSelecao: false,
                                empresas: [_ctx.props.empresa],
                                codigoSelecionado: _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao,
                                "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao) = $event)),
                                descricaoSelecionado: _ctx.state.item.itemNotaFiscal.descricao,
                                "onUpdate:descricaoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.descricao) = $event)),
                                disabled: !_ctx.props.editavel,
                                onChange: _ctx.obterEstoquesDisponiveis
                              }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado", "disabled", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_a_form_item, {
                            label: "Movimentar Estoque",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.item.itemNotaFiscal.movimentarEstoque,
                                "onUpdate:valor": [
                                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.movimentarEstoque) = $event)),
                                  _ctx.limparEstoques
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_a_form_item, {
                            label: "Compor Total",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.item.itemNotaFiscal.compoeTotal,
                                "onUpdate:valor": [
                                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.compoeTotal) = $event)),
                                  _ctx.calcularTotalNota
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_a_form_item, {
                            label: "Informações Adicionais",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.informacaoAdicional) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, _hoisted_47), [
                                [_vModelText, _ctx.state.item.itemNotaFiscal.informacaoAdicional]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, {
                    class: "ss-card",
                    titulo: "INFORMAÇÕES NA NOTA FISCAL DO FORNECEDOR"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_a_form_item, {
                            label: "Unidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_unidade, {
                                empresas: [_ctx.props.empresa],
                                codigoSelecionado: _ctx.state.item.codigoUnidadeNfFornecedor,
                                "onUpdate:codigoSelecionado": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.item.codigoUnidadeNfFornecedor) = $event)),
                                  _ctx.atualizarDadosFornecedor
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["empresas", "codigoSelecionado", "disabled", "onUpdate:codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_a_form_item, {
                            label: "Quantidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.item.quantidadeNfFornecedor,
                                "onUpdate:valor": [
                                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.item.quantidadeNfFornecedor) = $event)),
                                  _ctx.atualizarDadosFornecedor
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor Unitário",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.valorUnitarioNfFornecedor,
                                "onUpdate:valor": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.item.valorUnitarioNfFornecedor) = $event)),
                                  _ctx.atualizarDadosFornecedor
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_a_form_item, {
                            label: "Desconto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.descontoUnitarioNfFornecedor,
                                "onUpdate:valor": [
                                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.item.descontoUnitarioNfFornecedor) = $event)),
                                  _ctx.atualizarDadosFornecedor
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["valor", "disabled", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor total do item",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.valorTotalNfFornecedor,
                                "onUpdate:valor": [
                                  _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.item.valorTotalNfFornecedor) = $event)),
                                  _ctx.atualizarDadosFornecedor
                                ],
                                disabled: true
                              }, null, 8, ["valor", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_a_form_item, {
                            label: "CFOP",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_cfop, {
                                codigoSelecionado: _ctx.state.item.cfopNfFornecedor,
                                "onUpdate:codigoSelecionado": [
                                  _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.item.cfopNfFornecedor) = $event)),
                                  _ctx.atualizarCfopEntrada
                                ],
                                disabled: !_ctx.editavel
                              }, null, 8, ["codigoSelecionado", "disabled", "onUpdate:codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, {
                    class: "ss-card",
                    titulo: "COMO DESEJA EFETIVAR O RECEBIMENTO"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_a_form_item, {
                            label: "Unidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_unidade_produto_movimento, {
                                apenasUnidadePrincipal: true,
                                codigoProdutoDefinicao: _ctx.state.item.itemNotaFiscal.codigoProdutoDefinicao,
                                codigoUnidadeSelecionada: _ctx.state.item.itemNotaFiscal.codigoUnidade,
                                "onUpdate:codigoUnidadeSelecionada": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.codigoUnidade) = $event)),
                                descricao: _ctx.state.item.itemNotaFiscal.descricaoUnidade,
                                "onUpdate:descricao": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.descricaoUnidade) = $event)),
                                sigla: _ctx.state.item.itemNotaFiscal.siglaUnidade,
                                "onUpdate:sigla": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.siglaUnidade) = $event)),
                                fracionar: _ctx.state.item.itemNotaFiscal.fracionarUnidade,
                                "onUpdate:fracionar": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.fracionarUnidade) = $event)),
                                casasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisUnidade,
                                "onUpdate:casasDecimais": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.casasDecimaisUnidade) = $event)),
                                fatorConversao: _ctx.state.item.itemNotaFiscal.fatorConversao,
                                "onUpdate:fatorConversao": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.fatorConversao) = $event)),
                                disabled: !_ctx.editavel
                              }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "descricao", "sigla", "fracionar", "casasDecimais", "fatorConversao", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_a_form_item, {
                            label: "Quantidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              ((_ctx.state.item.itemNotaFiscal.codigoUnidade > 0))
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 0,
                                    quantidadeCasasDecimais: _ctx.state.item.itemNotaFiscal.casasDecimaisUnidade,
                                    fracionar: _ctx.state.item.itemNotaFiscal.fracionarUnidade,
                                    valor: _ctx.state.item.itemNotaFiscal.quantidade,
                                    "onUpdate:valor": [
                                      _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.quantidade) = $event)),
                                      _ctx.atualizarQtdEstoque
                                    ],
                                    disabled: !_ctx.editavel
                                  }, null, 8, ["quantidadeCasasDecimais", "fracionar", "valor", "disabled", "onUpdate:valor"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor Unitário",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.itemNotaFiscal.precoUnitario,
                                "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.precoUnitario) = $event)),
                                disabled: !_ctx.editavel,
                                onBlur: _ctx.calcularCusto,
                                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.calculaTotalItemEAtualizaTotalNota()))
                              }, null, 8, ["valor", "disabled", "onBlur"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_a_form_item, {
                            label: "Desconto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.itemNotaFiscal.valorDesconto,
                                "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.valorDesconto) = $event)),
                                disabled: !_ctx.editavel,
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.calculaTotalItemEAtualizaTotalNota()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor total do item",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.itemNotaFiscal.valorTotal,
                                "onUpdate:valor": [
                                  _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.valorTotal) = $event)),
                                  _ctx.calcularTotalNota
                                ],
                                disabled: true
                              }, null, 8, ["valor", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_a_form_item, {
                            label: "CFOP de Entrada",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregandoCfopEntrada
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_cfop, {
                                    codigoSelecionado: _ctx.state.item.itemNotaFiscal.impostos.codigoCfop,
                                    "onUpdate:codigoSelecionado": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos.codigoCfop) = $event)),
                                    disabled: !_ctx.editavel
                                  }, null, 8, ["codigoSelecionado", "disabled"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tabs, {
                    class: "ss-card",
                    defaultActiveKey: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "DETALHES DO ITEM"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_detalhe, {
                            item: _ctx.state.item.itemNotaFiscal,
                            "onUpdate:item": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                            editavel: _ctx.props.editavel,
                            onCalcular: _ctx.calcularCusto
                          }, null, 8, ["item", "editavel", "onCalcular"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        tab: "IMPOSTOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_impostos, {
                            impostos: _ctx.state.item.itemNotaFiscal.impostos,
                            "onUpdate:impostos": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.item.itemNotaFiscal.impostos) = $event)),
                            editavel: _ctx.props.editavel,
                            onCalcular: _ctx.calcularCusto,
                            onCalcularTributacoes: _cache[29] || (_cache[29] = ($event: any) => (_ctx.calcularTributacoes()))
                          }, null, 8, ["impostos", "editavel", "onCalcular"])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.item.itemNotaFiscal.movimentarEstoque)
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "3",
                            tab: "ESTOQUE"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_item_estoques, {
                                empresa: _ctx.props.empresa,
                                pessoa: _ctx.props.pessoa,
                                item: _ctx.state.item.itemNotaFiscal,
                                "onUpdate:item": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                                editavel: _ctx.props.editavel,
                                classeCss: "ss-modal-compras"
                              }, null, 8, ["empresa", "pessoa", "item", "editavel"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        tab: "CUSTO"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_recebimento_mercadorias_item_custo, {
                            empresa: _ctx.props.empresa,
                            item: _ctx.state.item,
                            "onUpdate:item": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.item) = $event)),
                            editavel: _ctx.props.editavel,
                            retornosCalculoCusto: _ctx.state.item.retornoCalculosCustos,
                            tiposCustosCadastrados: _ctx.props.tiposCustosCadastrados,
                            onCalcularCusto: _ctx.calcularCusto
                          }, null, 8, ["empresa", "item", "editavel", "retornosCalculoCusto", "tiposCustosCadastrados", "onCalcularCusto"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "5",
                        tab: "DADOS ESPECÍFICOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_item_dados_especificos, {
                            empresa: _ctx.props.empresa,
                            item: _ctx.state.item.itemNotaFiscal,
                            "onUpdate:item": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.item.itemNotaFiscal) = $event)),
                            editavel: _ctx.props.editavel
                          }, null, 8, ["empresa", "item", "editavel"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}